/** Colors */

export const primary_1 = "#f5d765";
export const primary_2 = "#ff9000";
export const primary_3 = "#ec0048";
export const primary_4 = "#8a45b6";
export const primary_5 = "#59a2d0";
export const primary_6 = "#c5fa8a";
export const primary_7 = "#272727";
export const primary_8 = "#d7d3ca";
export const primary_9 = "#e5e5e5";

export const text_primary = "rgb(240, 240, 240)";
export const text_primary_rev = "#211E1F";
export const text_primary_dimmed = "rgba(240, 240, 240, 0.8)";
export const text_dark_primary = "#211e1f";
export const text_secondary = "rgb(184, 184, 184)";
export const text_secondary_dimmed = "rgba(184, 184, 184, 0.8)";
export const text_tertiary = "#B8B8B8";
export const text_tertiary_dimmed = "#666666";

export const secondary_1 = "#000000";
export const secondary_2 = "#ffffff";

export const bg_dark_primary = "#141212";
export const bg_dark_secondary = "#211e1f";
export const bg_dark_tertiary = "#292727";

export const primary_but_modal_text = "#F0F0F0";
export const primary_but_modal_bg = "#292727";
export const primary_but_modal_text__hover = "#F9F9F9";
export const primary_but_modal_bg__hover = "#211e1f";
export const primary_but_modal_text__active = "#F9F9F9";
export const primary_but_modal_bg__active = "#141212";

export const primary_mobile_but_modal_text = "#211e1f";
export const primary_mobile_but_modal_bg = "#E5E5E5";
export const primary_mobile_but_modal_text__hover = "#141212";
export const primary_mobile_but_modal_bg__hover = "#F0F0F0";
export const primary_mobile_but_modal_text__active = "#141212";
export const primary_mobile_but_modal_bg__active = "#F9F9F9";

export const secondary_but_modal_text = "#211e1f";
export const secondary_but_modal_bg = "rgba(138, 138, 138, 0.1)";
export const secondary_but_modal_text__hover = "#141212";
export const secondary_but_modal_bg__hover = "rgba(138, 138, 138, 0.15)";
export const secondary_but_modal_text__active = "#141212";
export const secondary_but_modal_bg__active = "rgba(138, 138, 138, 0.2)";

export const secondary_mobile_but_modal_text = "#F0F0F0";
export const secondary_mobile_but_modal_bg = "rgba(138, 138, 138, 0.1)";
export const secondary_mobile_but_modal_text__hover = "#F9F9F9";
export const secondary_mobile_but_modal_bg__hover = "rgba(138, 138, 138, 0.15)";
export const secondary_mobile_but_modal_text__active = "#F9F9F9";
export const secondary_mobile_but_modal_bg__active = "rgba(138, 138, 138, 0.2)";

export const wr_yellow = "#eab34f";

export const gray_primary = "#e5e5e5";
export const gray_primary__hover = "#F0F0F0";
export const gray_primary__active = "#F9F9F9";

export const gray_secondary = "#8A8A8A";

export const gray_tertiary = "#F0F0F0";

export const default_white = "#F9F9F9";

export const dark_affirmative_green = "#4DF4D3";

export const lol_blue = "#0BC4E2";
export const lol_blue__hover = "#07BBD9";
export const lol_blue__active = "#02B2CF";

export const dark_lol_blue = "rgba(88,228,255,1)";
export const button_link_text = "rgba(53,160,187,1)";

export const val_primary_light = "#E76A74";
